<template>
  <div style="height: auto; min-height: 500px;">
    <div class="phone-selector-container">
      <div class="col" style="margin-bottom: 2rem;" v-if="$whitelabel.showLogo()">
        <img :src="require('../../../assets/sqrql_logo.png')" width="160px" height="160px">
      </div>
      <div class="col-12" style="margin-top: 3rem; margin-bottom: 3rem; min-height: 222px;" v-if="processing">
        <b-spinner variant="teal" label="Spinning"></b-spinner>
      </div>
      <div class="col-12" style="margin-top: 3rem; margin-bottom: 3rem;" v-else>
        <div class="col-12" style="min-height: 60px;">
          <b-alert variant="danger" :show="isAlert">{{ alert }}</b-alert>
        </div>
        <form method="post" @submit.prevent="reset" name="reset" v-if="!invalid">
          <div class="col-12" style="margin-top: 1rem;">
            <div class="col-12">
              <b-form-input
                id="password"
                v-model="password"
                type="password"
                required
                :placeholder="$t('resetpassword.password')"
              ></b-form-input>
            </div>
          </div>
          <div class="col-12" style="margin-top: 1rem;">
            <div class="col-12">
              <b-form-input
                id="repassword"
                v-model="repassword"
                type="password"
                required
                :placeholder="$t('resetpassword.repassword')"
              ></b-form-input>
            </div>
          </div>
          <div class="col-10 offset-1" style="margin-top: 2rem;">
            <b-button variant="primary" type="submit" block style="background-color: #009AB1; border-color: #009AB1;">Reset Password</b-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'reset-password',
    mounted () {
      this.tokenChecker()
    },
    data () {
      return {
        password: '',
        repassword: '',
        alert: this.$t('resetpassword.resetFailAlert3'),
        isAlert: false,
        processing: false,
        invalid: false
      }
    },
    methods: {
      tokenChecker: async function () {
        var self = this
        self.isAlert = false
        self.processing = true
        try {
          await axios.get(`${process.env.MYR_ROOT}/password_resets/${self.$route.params.token}`)
          self.processing = false
        } catch (error) {
          self.alert = self.$t('resetpassword.resetFailAlert3')
          self.isAlert = true
          self.processing = false
          self.invalid = true
        }
      },
      reset: async function () {
        var self = this
        self.isAlert = false
        self.processing = true
        try {
          if (!self.validatePassword(self.password)) {
            self.isAlert = true
            self.alert = self.$t('resetpassword.resetFailAlert4')
          } else if (self.password !== self.repassword) {
            self.isAlert = true
            self.alert = self.$t('resetpassword.resetFailAlert5')
          } else {
            await axios.patch(`${process.env.MYR_ROOT}/password_resets/${self.$route.params.token}`, { password: self.password, password_confirmation: self.repassword })
            this.$router.push({ name: 'Login' })
          }
          self.processing = false
        } catch (error) {
          console.log(error)
          self.alert = self.$t('resetpassword.resetFailAlert6')
          self.isAlert = true
          self.processing = false
        }
      },
      validatePassword (password) {
        // Validate lowercase letters
        var lowerCaseLetters = /[a-z]/g
        if (!password.match(lowerCaseLetters)) {
          return false
        }

        // Validate capital letters
        var upperCaseLetters = /[A-Z]/g
        if (!password.match(upperCaseLetters)) {
          return false
        }

        // Validate numbers
        var numbers = /[0-9]/g
        if (!password.match(numbers)) {
          return false
        }

        // Validate length
        if (password.length < 8) {
          return false
        }
        return true
      }
    }
  }
</script>

<style scopped>
.phone-selector-container {
  background-color: white;
  max-width: 420px !important;
  padding: 20px !important;
  margin: 0 auto 0 auto !important;
  height: 552px !important;
  width: 420px !important;
  overflow: hidden;
  text-align: center !important;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
}
.text-teal {
  color: #009AB1;
}
</style>
